import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useKeycloak } from '@josempgon/vue-keycloak'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'AuthEntry',
    component: () => import('@/pages/Callback.vue')
  },
  {
    path: '/callback',
    name: 'Callback',
    component: () => import('@/pages/Callback.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/pages/dashboard/DashboardPage.vue'),
    meta: { adminOnly: true }
  },
  {
    path: '/prices',
    name: 'Prices',
    component: () => import('@/pages/prices/PricesPage.vue'),
    meta: { adminOnly: true }
  },
  {
    path: '/log',
    name: 'Log',
    component: () => import('@/pages/LogPage.vue')
  },
  {
    path: '/topups',
    name: 'TopUps',
    component: () => import('@/pages/TopUpsPage.vue')
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('@/pages/UsersPage.vue')
  },
  {
    path: '/price-activations',
    name: 'PriceActivations',
    component: () => import('@/pages/prices/PriceRentalPage.vue'),
    meta: { adminOnly: true }
  },
  {
    path: '/requests',
    name: 'Requests',
    component: () => import('@/pages/requests/RequestsPage.vue'),
    meta: { adminOnly: true }
  },
  {
    path: '/partners',
    name: 'Partners',
    component: () => import('@/pages/partners/PartnersPage.vue'),
    meta: { adminOnly: true }
  },
  {
    path: '/payouts',
    name: 'Payouts',
    component: () => import('@/pages/payouts/PayoutsPage.vue'),
    meta: { adminOnly: true }
  },
  {
    path: '/reference/countries',
    name: 'Countries',
    component: () => import('@/pages/reference/CountriesPage.vue'),
    meta: { adminOnly: true }
  },
  {
    path: '/reference/services',
    name: 'Services',
    component: () => import('@/pages/reference/ServicesPage.vue'),
    meta: { adminOnly: true }
  },
  {
    path: '/paidusers',
    name: 'PaidUsers',
    component: () => import('@/pages/PaidUsersPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Глобальный guard для ограничения доступа isPPA
router.beforeEach((to, from, next) => {
  const { keycloak } = useKeycloak()
  const info = keycloak.value?.tokenParsed
  const isAdmin = info && (
    (Array.isArray(info.roles) && info.roles.includes('ROLE_superadmin')) ||
    Object.values(info.resource_access || {}).some((r: any) => (r.roles || []).includes('ROLE_superadmin'))
  )
  const isPPA = info && (
    (Array.isArray(info.roles) && info.roles.includes('ROLE_ppa')) ||
    Object.values(info.resource_access || {}).some((r: any) => (r.roles || []).includes('ppa'))
  )

  // Если маршрут только для админа, а пользователь только ppa — редирект на /log
  if (to.meta.adminOnly && isPPA && !isAdmin) {
    return next('/log')
  }
  next()
})

export default router
